import {alias, createModelSchema, custom, deserialize, serialize, SKIP} from "serializr";
import {Schema} from "@/common/Schema";
import {BaseObject} from "@/common/BaseObject";

export class GroupModel extends BaseObject {

    constructor() {
        super();

        this._name = null;
    }

    get name() {
        return this._name;
    }

    set name(value) {
        this._name = value;
    }

    copy() {
        return super.copy();
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new GroupModel());
        }
        return super.clone(target);
    }

    valid() {
        return this._name !== null && this._name !== '';
    }

    static schema() {
        return custom((v) => {
            return v ? serialize(GroupModel, v) : SKIP;
        }, (v) => {
            return deserialize(GroupModel, v);
        });
    }
}

createModelSchema(GroupModel, {
    _name: alias("name", Schema.primitive()),
});